import { HTMLAttributes } from 'react';

export default function Favo(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      width='18'
      height='17'
      viewBox='0 0 18 17'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M6.5419 16.6855C5.19859 16.6855 3.94579 15.9497 3.2731 14.7631L0.814817 10.4235C0.142131 9.23689 0.142131 7.76309 0.814817 6.5786L3.2731 2.23898C3.94579 1.0503 5.19653 0.314453 6.5419 0.314453H11.4585C12.8018 0.314453 14.0546 1.0503 14.7273 2.23689L17.1856 6.57651C17.8582 7.76309 17.8582 9.23689 17.1856 10.4214L14.7273 14.761C14.0546 15.9476 12.8038 16.6834 11.4585 16.6834H6.5419V16.6855Z' />
    </svg>
  );
}
